import Link from "next/link"
import cn from "classnames"
import Image from "components/Image"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import richText from "utilities/richText"

function Card({ image, heading, content, link, link_label, columns }) {
  return (
    <div className="relative z-10 flex flex-col justify-between rounded-10 bg-springWood shadow-md">
      {link.href ? (
        <Link href={getStoryblokLink(link)}>
          <div className="box-border max-w-full overflow-hidden">
            <Image
              src={image?.filename}
              alt={image?.alt}
              placeholder={image?.blurDataURL ? "blur" : "empty"}
              blurDataURL={image?.blurDataURL}
              width={585}
              height={250}
              className="h-[250px] w-full object-cover transition-all duration-700 hover:scale-105 hover:opacity-80"
            />
          </div>
        </Link>
      ) : (
        <Image
          src={image?.filename}
          alt={image?.alt}
          placeholder={image?.blurDataURL ? "blur" : "empty"}
          blurDataURL={image?.blurDataURL}
          width={585}
          height={250}
          className="h-[250px] w-full object-cover"
        />
      )}

      <div className="flex h-full flex-col justify-between pb-7 pl-5 pr-7 pt-5">
        <div>
          {link.href ? (
            <Link href={getStoryblokLink(link)}>
              <h2
                className={cn("pb-5 text-teal-dark hover:text-teal", {
                  "text-l3 lg:text-xl1": columns === "two-columns",
                  "font-secondary text-l1 lg:text-l2": columns === "three-columns",
                })}
              >
                {heading}
              </h2>
            </Link>
          ) : (
            <h2
              className={cn("pb-5 text-teal-dark", {
                "text-l3 lg:text-xl1": columns === "two-columns",
                "font-secondary text-l1 lg:text-l2": columns === "three-columns",
              })}
            >
              {heading}
            </h2>
          )}
          <div>{richText(content)}</div>
        </div>
        {link && link_label ? (
          <Link
            href={getStoryblokLink(link)}
            className="block pt-5 font-secondary text-m1 font-bold text-teal-dark underline hover:no-underline"
          >
            {link_label}
          </Link>
        ) : null}
      </div>
    </div>
  )
}

export default function CardSection({ blok }) {
  return (
    <section className="isolate px-6 py-12 lg:pb-16">
      <div
        className={cn("relative mx-auto grid max-w-screen-xl place-items-stretch sm:grid-cols-2", {
          "gap-16 lg:grid-cols-2": blok.columns === "two-columns",
          "gap-6 lg:grid-cols-3": blok.columns === "three-columns",
        })}
      >
        {blok.cards.map((card) => (
          <Card {...card} columns={blok.columns} key={card.heading} />
        ))}
      </div>
    </section>
  )
}
